define('core/helpers',[
	'core/can',
	'models/Session',
	'moment'
], function (can, Session, moment) {

	var helpers = {

		// --------------------------------------------------
		// General
		// --------------------------------------------------

		'ifand': function (a, b, options) {
			if (!!a() && !!b()) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'ifor': function (a, b, options) {
			if (!!a() || !!b()) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'ifExists': function (value, options) {
			if (!(value() === null || value() === undefined)) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isValueNegative': function (value, options) {
			if (typeof value === 'function') value = value();
			if (value === undefined || value === null) value = 0;
			if (value < 0) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},


		// --------------------------------------------------
		// Dev
		// --------------------------------------------------

		'isDev': function (options) {
			if (document.domain === 'rcm.rcm.lan') {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		// --------------------------------------------------
		// Session
		// --------------------------------------------------

		'isRegular': function (options) {
			if (!Session.attr('_isVendor')) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isVendor': function (options) {
			if (Session.attr('_isVendor')) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isDemo': function (options) {
			if (config.api_url === "https://demorcmapi.axxessweb.com") {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'ProviderName': function (id) {
			if (typeof id === 'function') id = id();
			var provider = Session.attr('Providers').findById(id);
			return provider ? provider.attr('Name') : 'Unknown';
		},

		'isActionAllowed': function (action, options) {
			if (typeof action === 'function') action = action();
			if (App.isActionAllowed(action)) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isBillingClient': function (options) {
			if (Session.attr('isBillingClient')) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isImpersonator': function (options) {
			if (Session.attr('isImpersonating')) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		'isAuthorizedBiller': function (options) {
			if (Session.attr('isAuthorizedBiller')) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		},

		// --------------------------------------------------
		// Model
		// --------------------------------------------------

		'isNew': function (model, options) {
			if (model().isNew()) {
				return options.fn();
			} else {
				return options.inverse();
			}
		},

		'ifErrors': function (model, attr, options) {
			return;
			if (model().errors(attr) !== null) {
				return options.fn();
			}
		},

		'showErrors': function (model, attr, messageAttr, options) {
			return can.capitalize(messageAttr || attr) + ' ' + model().errors(attr).join(', ');
		},

		// --------------------------------------------------
		// Links
		// --------------------------------------------------

		'url': function (options) {
			var params = {};
			can.each(options.hash, function (value, name) {
				params[name] = can.isFunction(value) ? value() : value;
			});
			return can.route.url(params);
		},

		'link': function (text, options) {
			var params = {};
			can.each(options.hash, function (value, name) {
				params[name] = can.isFunction(value) ? value() : value;
			});
			return can.stache.safeString(can.route.link(text, params));
		},

		'linkUnlessCurrent': function (text, options) {
			var params = {};
			can.each(options.hash, function (value, name) {
				params[name] = can.isFunction(value) ? value() : value;
				can.route.attr(name);
			});
			if (can.route.current(params)) {
				return can.stache.safeString(text);
			} else {
				return can.stache.safeString(can.route.link(text, params));
			}

		},

		// --------------------------------------------------
		// Formatting
		// --------------------------------------------------

		'formatDate': function (date, format) {
			if (date === undefined) return '';
			date = date();
			return date ? moment.utc(date).format(format) : '.';
		},

		'formatDateFromNow': function (date, isUtc) {
			if (!date || !date()) return '';
			if(isUtc === false) date = date().replace("Z", "");
			else date = date();
			return moment(date).fromNow();
		},

		'formatMoney': function (value) {
			if (typeof value === 'function') value = value();
			if (value === undefined || value === null) return '';
			if (value >= 0) {
				return "$" + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			} else {
				return "($" + Math.abs(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + ")";
			}
		},

		'formatPhone': function (value) {
			if (typeof value === 'function') value = value();
			return '(' + value.substr(0, 3) + ') ' + value.substr(3, 3) + '-' + value.substr(6, 4);
		},

		// --------------------------------------------------
		// CSS Classes
		// --------------------------------------------------
		'cssInvoiceStatus': function (status, options) {
			var status = typeof status === 'function' ? status() : status;
			switch (status) {
				case 0:
				case 1: return 'info';
				case 2: return 'success';
				case 3: return 'warning';
				case 4: return 'danger'
			}
		},

		'cssClaimStatus': function (medicareStatus) {
			switch (medicareStatus()) {
				case 'Suspense': return 'status-suspense';
				case 'Paid': return 'status-paid';
				case 'RTP': return 'status-rtp';
				case 'Rejected': return 'status-rejected';
				case 'ADR': return 'status-adr';
				case 'Denied': return 'status-denied';
				default: return 'status-unknown';
			}
		},

		'cssClaimStatusPanel': function (medicareStatus) {
			switch (medicareStatus()) {
				case 'Suspense': return 'panel-info';
				case 'Paid': return 'panel-success';
				case 'RTP':
				case 'Rejected': return 'panel-warning';
				case 'ADR':
				case 'Denied': return 'panel-danger';
				default: return 'panel-default';
			}
		}
	}

	for (var key in helpers) {
		can.stache.registerHelper(key, helpers[key]);
	}
});
